import { render, staticRenderFns } from "./SurveyOverviewParent.vue?vue&type=template&id=c37790ea"
import script from "./SurveyOverviewParent.vue?vue&type=script&lang=js"
export * from "./SurveyOverviewParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports